import type {StateCreator} from 'zustand'
import type {DiffLine} from '../../types'
import type {DiffAnchor} from '@github-ui/diffs/types'

export type EnterDialogModeFn = (gridCellId: string) => void
export type DisableDialogModeFn = () => void

export interface DialogModeSlice {
  dialogMode: {
    activeGridCellId: string | null
  }
  dialogModeActions: {
    enableDialogMode: EnterDialogModeFn
    disableDialogMode: DisableDialogModeFn
  }
}

export type DiffLinesSliceOpts = {
  diffAnchor: DiffAnchor
  diffLines: DiffLine[]
  fileLineCount: number
  isSplitView: boolean
}

export const createDialogModeSlice = (): StateCreator<DialogModeSlice, [['zustand/devtools', never]]> => set => ({
  dialogMode: {
    activeGridCellId: null,
  },
  dialogModeActions: {
    enableDialogMode: (gridCellId: string) =>
      set(() => ({dialogMode: {activeGridCellId: gridCellId}}), undefined, `dialogMode#enabled`),
    disableDialogMode: () => set(() => ({dialogMode: {activeGridCellId: null}}), undefined, `dialogMode#disabled`),
  },
})
